// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"73662cf1","105":"108da25f","200":"e87ee118","239":"6dff05eb","453":"9af1c1b4","455":"0f2aac79","468":"a6e72a77","488":"e5b6ae61","977":"bb8d7f34"}[chunkId] + ".chunk.js";
};